<template>
    <div class="empty-state-wrapper" :class="[emptyStateSize]">
        <!-- Illustration -->
        <empty-state-illustration class="illustration"/>
        <!-- Title -->
		<div class="title">{{title}}</div>
        <!-- Description -->
		<div class="description" v-html="description"/>
        <!-- Button -->
        <button-primary
        v-if="hasButton"
        buttonSize="medium"
        :label="buttonLabel"
        :icon="buttonIcon"
        :iconPosition="buttonIconPosition"
        @clicked="emit('clicked')"/>
    </div>
</template>

<script setup>
import ButtonPrimary from '@/components/generic/buttons/Primary'
/* Vue */
import { computed, defineAsyncComponent } from 'vue'
/* Emmitters */
const emit = defineEmits(['clicked'])

/** Props received
@emptyStateSize {String} [none(default), small]
@illustration { String }
@title { String }
@description { String }
@hasButton {Boolean}
@buttonLabel { String }
@buttonIcon { String }
@buttonIconPosition { String }
*/
const props = defineProps({
    emptyStateSize: String,
    illustration: String,
	title: String,
	description: String,
    hasButton: Boolean,
    buttonLabel: String,
    buttonIcon: String,
    buttonIconPosition: String
})

/* Computed for illustration */
const emptyStateIllustration = computed(() => {
	const iconName = props.illustration
	return defineAsyncComponent(() => import('@/assets/icons/illustrations/' + iconName + '.svg?inline'))
})
</script>

<style lang="scss" scoped>
.empty-state-wrapper {
    width: 100%;
    max-width: 1168px;
    margin: 0 auto;
    padding: 16px;

    display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
    text-align: center;
    gap: 8px;

    background-color: var(--secondary-light-4);
    border-radius: 16px;

    .illustration {
		width: 144px;
		height: 144px;

        flex-shrink: 0;

        :deep(.change-color-fill) {
            fill: var(--secondary-light-1)
        }
	}

    .title {
        @include H5-Medium;
        line-height: 20px;
        color: var(--secondary-dark-2);
    }

    .description {
        @include H7-Regular;
        line-height: 16px;
        color: var(--secondary-dark-2);
    }

    button {
        margin-top: 8px;
    }

    &.small {
        gap: 4px;

        .illustration {
            width: 88px;
            height: 88px;

            flex-shrink: 0;
        }

        .title {
            @include H6-Medium;
            line-height: 16px;
        }

        .description {
            @include H7-Regular;
        }
    }
}
</style>
